import React from "react";
import { FormattedMessage } from "react-intl";
import { Grid, CircularProgress } from "@material-ui/core";
import { Card } from "../common/card/card";
import { Header } from "../common/title/header";
import { useWorkOrderStyles, CardTitle } from "./workOrderDetails";
import WarningIcon from "../common/icons/WarningIcon";
import WorkOrderAssignementInfoSection from "./WorkOrderAssignementInfoSection";

const WorkOrderAssignementInfo = ({ assignmentInformation, isAdmin, customerPhoneNumber }) => {
    const classes = useWorkOrderStyles();
    return (
        <>
            <Grid container spacing={2}>
                {isAdmin && (
                    <Grid item xs={12} className={classes.noBottomPadding}>
                        <Header>
                            <FormattedMessage
                                id="admin.work-order-details.wo-info.assignment-info-title"
                                defaultMessage="Assignment information"
                                description="Admin Assignment information title"
                            />
                        </Header>
                    </Grid>
                )}

                <Grid item xs={12}>
                    {assignmentInformation ? (
                        <>
                            {typeof assignmentInformation === "string" && (
                                <>
                                    <Card>
                                        <CardTitle>
                                            <FormattedMessage
                                                id="admin.work-order-details.wo-info.assignment-details-title"
                                                defaultMessage="Assignment details"
                                                description="Admin Assignment details title"
                                            />
                                        </CardTitle>
                                        <Grid container className={classes.alert}>
                                            <Grid item xs={1}>
                                                <WarningIcon color="primary" />
                                            </Grid>
                                            <Grid item xs={11} className={classes.alertMessage}>
                                                <FormattedMessage
                                                    id="admin.work-order-details.wo-info.assignment-info-tmf-error"
                                                    defaultMessage="TMF-638 Service Inventory API was unable to return assignment information. Please call xxxxxxx for assistance."
                                                    description="TMF-638 Service Inventory API was unable to return assignment information. Please call xxxxxxx for assistance."
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </>
                            )}
                            {typeof assignmentInformation !== "string" &&
                                assignmentInformation?.map((assignment) => (
                                    <>
                                        {assignment?.pendingServiceInventoryInformation?.length > 0 && (
                                            <WorkOrderAssignementInfoSection
                                                classes={classes}
                                                title={"admin.work-order-details.wo-info.assignment-info-pending-assignment-title"}
                                                assignmentInfo={assignment?.pendingServiceInventoryInformation}
                                                accessID={assignment?.accessId}
                                            />
                                        )}
                                        {assignment?.activeServiceInventoryInformation?.length > 0 && (
                                            <WorkOrderAssignementInfoSection
                                                classes={classes}
                                                title={"admin.work-order-details.wo-info.assignment-info-current-assignment-title"}
                                                assignmentInfo={assignment?.activeServiceInventoryInformation}
                                                accessID={!assignment?.pendingServiceInventoryInformation?.length > 0 && assignment?.accessId}
                                            />
                                        )}
                                    </>
                                ))}
                        </>
                    ) : (
                        <Card>
                            <div className={classes.loader}>
                                <CircularProgress />
                            </div>
                        </Card>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default WorkOrderAssignementInfo;
